var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_517_453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.6875C8.37056 12.6875 8.26562 12.5826 8.26562 12.4531C8.26562 12.3237 8.37056 12.2188 8.5 12.2188",
    stroke: "#E33629",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.6875C8.62944 12.6875 8.73438 12.5826 8.73438 12.4531C8.73438 12.3237 8.62944 12.2188 8.5 12.2188",
    stroke: "#E33629",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.3438V5.65625",
    stroke: "#E33629",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51313 1.6001C9.42013 1.41073 9.27588 1.25122 9.09681 1.13967C8.91775 1.02812 8.711 0.968994 8.5 0.968994C8.289 0.968994 8.08225 1.02812 7.90319 1.13967C7.72413 1.25122 7.57988 1.41073 7.48688 1.6001L1.56626 13.6613C1.49499 13.8063 1.46184 13.9671 1.46995 14.1284C1.47805 14.2898 1.52715 14.4464 1.61259 14.5835C1.69803 14.7206 1.817 14.8337 1.95828 14.912C2.09954 14.9904 2.25846 15.0315 2.42001 15.0313H14.58C14.7416 15.0315 14.9004 14.9904 15.0418 14.912C15.183 14.8337 15.302 14.7206 15.3874 14.5835C15.4729 14.4464 15.5219 14.2898 15.5301 14.1284C15.5382 13.9671 15.505 13.8063 15.4338 13.6613L9.51313 1.6001Z",
    stroke: "#E33629",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_517_453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.c3a12444d4f3a48d825b03ea10da9077.svg";
export { ForwardRef as ReactComponent };